import { Box, BoxProps, ColorOptions, Icon, IconOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { FC } from 'react'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import styles from './styles'
import { TabProps, TabState, TabType } from './types'

const Tab: FC<TabProps> = ({
  iconId,
  title = '',
  isDisabled,
  onSelected,
  state,
  type = TabType.default,
  onLayout,
}: TabProps) => {
  const didSelectTab = (): void => {
    onSelected()
  }

  // Simplify this styling - It depends on type and state hence nesting is required
  const itemStyle = { ...styles[type].item, ...styles[type].states[state].item } as BoxProps
  const textStyle = { ...styles[type].textStyle, ...styles[type].states[state].textStyle } as TextProps

  return (
    <ModBox
      onPress={(evt: any) => [onLayout && onLayout(evt), didSelectTab()]}
      {...itemStyle}
      disabled={isDisabled}
      accessibilityRole={'tabbar-' + title?.replaceAll(' ', '')}
      testID={'tabbar-' + title?.replaceAll(' ', '')}
      underlayColor={styles[type].underlayColor as ColorOptions}>
      <Box {...styles[type].viewStyle}>
        <Icon
          id={iconId as IconOptions}
          color={styles[type].states[state].iconStyle.color as ColorOptions}
          size={styles[type].states[state].iconStyle.size ?? 12}
          hide={!iconId}
        />
        <Spacer direction="horizontal" size={4} hide={!iconId} />
        <Spacer direction="horizontal" size={10} hide={type !== TabType.arrow} />
        <Text {...textStyle} hide={!(title?.length > 0)}>
          {title}
        </Text>
      </Box>
    </ModBox>
  )
}
export { TabType, TabState }
export default Tab
